module.exports = __webpack_public_path__ + "img/52f00e9.webp";